var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{style:({backgroundImage:
    `linear-gradient(to right, rgba(255, 255, 255, 0.85) -100%, rgba(255, 255, 255, 1) 300%),
    url(${_vm.imgSrc[_vm.nowRouterMainCat-1]})`}),attrs:{"id":"categoryResult"}},[_c('div',{staticClass:"content"},[_c('div',{staticClass:"treeArea"},[_c('CategoryTree')],1),_c('div',{staticClass:"itemArea"},[_c('CategoryResultDetail')],1)])])
}
var staticRenderFns = []

export { render, staticRenderFns }